import React, { Fragment, useContext, useEffect, useState } from "react";

import { post } from 'axios';
// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils
import { _O } from "../../../../../modules/utils";

// UI
import { IC, Doctor } from "../../../../../resources/Assets";
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart } from "../../../../Layout";
import { DoctorMessage } from "../../../SM.Layers";
import { ScrollToTop } from "../../../../common/ScrollToTop/ScrollToTop";

// Temp Images
import _T_MEAL from "../../../../../resources/images/user/user_meal_photo01.jpg";

import {  PostApi1107 } from "../../../../../modules/network/padoPost";

import { SUBS, SubMenu } from "../../History";

export const DeleteLayer = (props) => {
    const { userinfo, cfg, phonecfg } = useContext(AppContext);
    const { seqNo, reloadList, periodType, startDate, endDate, setContentsList } = props;

    const request1107 = (userinfo, cfg, seqNo) => {
        PostApi1107(userinfo, cfg, phonecfg, seqNo)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                // 페이지 리스트 새로고침
                reloadList(userinfo, cfg, periodType, startDate, endDate);
            } else {
                console.log("LOGOUT!!!");
            }
        })
        .catch(err => {
            console.log(err);
        });
    };


    return (
        <div className="blacklayer-container delete-confirm-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">삭제</div>

                        <div className="delete-confirm-box">
                            <p>기록을 삭제 하겠습니까?</p>
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a onClick={() => request1107(userinfo, cfg, seqNo)} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};